import React from 'react';
import { FormattedMessage } from 'react-intl';
import View from 'components/_/common/view/list/ListView';
import { RouteComponentProps } from 'react-router';
import { wire } from 'react-hot-wire';
import BattlesService, { HallOfFameDateLimit } from '../../services/battles/BattlesService';
import HallOfFame from './hof/HallOfFame';
import useGetHallOfFame from './hook/api/useGetHallOfFame';

export type HallOfFameViewProps = RouteComponentProps<{ tab: string }>;
export type HallOfFameViewWiredProps = HallOfFameViewProps & { 'services.battlesService': BattlesService };

const tabToLimit: { [key: string]: HallOfFameDateLimit } = {
	week: HallOfFameDateLimit.ONE_WEEK,
	month: HallOfFameDateLimit.ONE_MONTH,
};

export const HallOfFameView = (props: HallOfFameViewWiredProps) => {
	const { tab } = props.match.params;
	const getHallOfFameQuery = useGetHallOfFame({ ...props, limit: tabToLimit[tab] || HallOfFameDateLimit.ONE_WEEK });

	return (
		<View
			name="battlesHOF"
			i18nKey="battle-hof"
			config={{
				search: false,
			}}
			tabs={{
				url: '/battles/halloffame/${tab}', // eslint-disable-line no-template-curly-in-string
				list: ['week', 'month'].map(tab => ({
					tab,
					content: <FormattedMessage id={`battle-hof.tabs.${tab}`} />,
				})),
			}}
		>
			<hr />
			<HallOfFame tab={tab} query={getHallOfFameQuery} />
		</View>
	);
};

export default wire<HallOfFameViewWiredProps, HallOfFameViewProps>(['services.battlesService'], HallOfFameView);
